import styled from "styled-components";
import { motion } from "framer-motion";

export const TransitionWrapper = styled(motion.div)`
  width: 100%;
`;
